import tsanaToken from "../abis/development/tokens/tsanaToken";

export default {
  name: "TSANA",
  abi: tsanaToken.abi,
  contractAddress: "0x28fb057cbea63e4457a9c792b3ee0cd4a9a5cedd",
  decimals: 18,
};
